
@if(haveSession()){
  <ta-layout></ta-layout>
} @else {
  <main class="auth-splash">
    <img src="assets/images/platform-logo.svg" alt="Travel Allowance Platform" width="240" class="mb-16" />
    <p-progressBar mode="indeterminate" [style]="{height: '6px', width: '33%'}"></p-progressBar>
    <div class="status-message mt-8">
      Logging you in...
    </div>
  </main>
}
<loading-indicator [isGlobal]="true"></loading-indicator>
